<template>
  <div class="mt-5">
    <b-row class="mt-5">
      <b-col class="mt-5 pr-4" order-lg="2" cols="12" lg="6">

        <b-row class="header-title"><slot name="title"></slot></b-row>
        <b-row class=""><slot name="subtitle"></slot></b-row>
        <b-row class=""><slot name="body"></slot></b-row>

        <b-row class="mt-5"><slot name="button"></slot></b-row>

      </b-col>

        <b-col class="mt-5  " order-lg="1" cols="12" lg="6">

          <slot name="image"></slot>
        </b-col>

    </b-row>

  </div>
</template>
<script>

export default {
  name: "S11",
}
</script>
<style scoped>
.header-title {
  font-family: 'Avini', 'Vazir', sans-serif !important;
}
</style>